"use client"
import React from 'react'
import Navbar from '../../components/agent/common/Navbar'
import MainAgentDocuments from "../../components/agent/documents/MainDocuments"

const AgentDocuments = () => {

  return (
    <div className="min-h-screen">
    <Navbar />
    <main className="p-4 md:p-8">
     <MainAgentDocuments/>
    </main>
  </div>
  )
}

export default AgentDocuments